var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.795 22.8587C8.795 22.4725 8.78042 21.2004 8.78042 19.6237C8.78042 18.5208 9.14458 17.8017 9.55667 17.435C6.96208 17.1346 4.23208 16.1212 4.23208 11.5875C4.23208 10.2967 4.68875 9.24082 5.435 8.41457C5.31583 8.11457 4.91292 6.91207 5.55083 5.28373C5.55083 5.28373 6.53208 4.9654 8.76583 6.4954C10.6821 5.96744 12.7054 5.96744 14.6217 6.4954C16.8538 4.9654 17.8346 5.28373 17.8346 5.28373C18.4729 6.91207 18.0721 8.11498 17.9504 8.41457C18.6987 9.24082 19.1512 10.2954 19.1512 11.5875C19.1512 16.1312 16.4179 17.1321 13.8108 17.4242C14.2329 17.7917 14.6063 18.5121 14.6063 19.6171C14.6063 21.1971 14.5917 22.4712 14.5917 22.8587C14.5917 23.1762 14.8021 23.5425 15.3958 23.4291C20.0396 21.8633 23.3863 17.4308 23.3863 12.2075C23.3863 5.67498 18.15 0.37915 11.6917 0.37915C5.23583 0.37915 0 5.67373 0 12.2075C0 17.4329 3.35 21.8666 8.00083 23.43C8.58208 23.5391 8.795 23.1737 8.795 22.8587Z",
    fill: "#D0CFCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.6b9615c9ca7aeb973d1a4731984953f8.svg";
export { ForwardRef as ReactComponent };